import { h } from "preact";
import { Router as PreactRouter, route } from "preact-router";
import { PATH_LOGIN, PATH_DIARY } from "../routes";
import { history } from "src/support/history";
import { PageTransitionSupport } from "maji";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import { isAuthenticated } from "../support/auth";
import { LoginPage } from "../modules/login";
import {
  HappinessSubmitterPage,
  HappinessOverviewPage,
} from "../modules/diary";
import { ManagersPage } from "../modules/manager";
import { DashboardPage } from "../modules/dashboard";

const Router = PageTransitionSupport.augmentRouter(PreactRouter, history);

const handleRoute = async e => {
  const isAuthed = await isAuthenticated();
  switch (e.url) {
    case "/":
    case PATH_LOGIN:
      if (isAuthed) route(PATH_DIARY, true);
      break;
    default:
      if (!isAuthed) route(PATH_LOGIN, true);
  }
};

const App = () => (
  <div>
    <Router onChange={handleRoute} history={history}>
      <LoginPage default path="/login" />
      <HappinessSubmitterPage path="/diary" />
      <HappinessOverviewPage path="/overview/:userId?" />
      <ManagersPage path="/managers" />
      <DashboardPage path="/dashboard" />
    </Router>
    <ToastContainer autoClose={2000} hideProgressBar={true} />
  </div>
);

export default App;



// WEBPACK FOOTER //
// ./src/containers/App.js